module.exports = __webpack_public_path__ + "img/user.8ff8ee23.png";